module.exports = __webpack_public_path__ + "static/about-insta-6-6a3b428a4b0f01df53a5ab49abe64f57.jpg";